<template>
  <div class="progress-steps">
    <ul class="list-unstyled multi-steps">
      <li :class="{'is-active': step == 1}">
      </li>
      <li :class="{'is-active': step == 2}">
      </li>
      <li :class="{'is-active': step == 3}">
      </li>
      <li :class="{'is-active': step == 4}">
      </li>
      <li :class="{'is-active': step == 5}">
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "progress-steps",
  props: {
    step: Number
  }
};
</script>

<style lang="scss">
$white: #fff;
$grey-light: #dddddd;

%remain-steps {
  &:before {
    content: counter(stepNum);
    font-family: inherit;
    font-weight: 700;
  }
  &:after {
    background-color: $grey-light;
  }
}

.progress-steps {
  margin: auto;
  max-width: 700px;
  margin-bottom: 20px;
}

.multi-steps {
  display: table;
  table-layout: fixed;
  width: 100%;
  transition: all 1s cubic-bezier(0, 0, 0.2, 1);
  > li {
    counter-increment: stepNum;
    text-align: center;
    display: table-cell;
    position: relative;
    color: #9abcbf;
    text-transform: uppercase;
    font-size: 0.8rem;
    font-weight: 500;
    transition: all 1s cubic-bezier(0, 0, 0.2, 1);
    z-index: 5;

    p {
      margin-top: 6px;
      margin-bottom: 0;
    }

    &:before {
      background-color: #9abcbf;
      color: white;
      content: counter(stepNum);
      display: block;
      margin: 0 auto 4px;
      width: 36px;
      height: 36px;
      line-height: 32px;
      text-align: center;
      font-weight: bold;
      font-size: 1.05rem;
      border: {
        width: 2px;
        style: solid;
        color: #9abcbf;
        radius: 50%;
      }
    }
    &:after {
      content: "";
      height: 4px;
      width: 100%;
      background-color: #9abcbf;
      position: absolute;
      top: 16px;
      left: 50%;
      z-index: -1;
      transition: all 1s cubic-bezier(0, 0, 0.2, 1);
    }
    &:last-child {
      &:after {
        display: none;
        transition: all 1s cubic-bezier(0, 0, 0.2, 1);
      }
    }

    &.is-active {
      @extend %remain-steps;
      color: #e31b18;
      transition: all 1s cubic-bezier(0, 0, 0.2, 1);
      &:before {
        background: #e31b18;
        border-color: #e31b18;
        cursor: initial;
        transition: all 1s cubic-bezier(0, 0, 0.2, 1);
      }

      ~ li {
        color: #808080;
        @extend %remain-steps;
        transition: all 1s cubic-bezier(0, 0, 0.2, 1);
        &:before {
          background-color: $grey-light;
          border-color: $grey-light;
          cursor: initial;
          transition: all 1s cubic-bezier(0, 0, 0.2, 1);
        }
      }
    }
  }
}
</style>